var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VideoContainer',{attrs:{"roomPic":_vm.roomPic,"showControls":_vm.showControls,"isLiveStream":false,"videoSource":_vm.mVideoSource,"roomId":_vm.roomId,"isVideoContain":_vm.isVideoContain}})}
var staticRenderFns = []

export { render, staticRenderFns }